/**
 * OpenAI GPT-Image-1.5 官方文生图（同步）：POST /v1/images/generations
 * 返回 b64_json，前端转 File 后上传业务服务，得到可长期访问的 URL。
 */
import axios from 'axios'
import { extractApiErrorMessage } from '../../extract-api-error-message'

var IMAGES_PATH = '/v1/images/generations'
var DEFAULT_MODEL = 'gpt-image-1.5'
var ALLOWED_SIZES = ['1024x1024', '1536x1024', '1024x1536']

function getOpenAIConfig() {
  return {
    baseURL: (process.env.VUE_APP_OFFICIAL_SORA2_BASE_URL || 'https://api.openai.com').replace(/\/$/, ''),
    apiKey: (process.env.VUE_APP_OFFICIAL_SORA2_API_KEY || '').trim(),
    model: process.env.VUE_APP_OFFICIAL_GPT_IMAGE_1_5_MODEL || DEFAULT_MODEL
  }
}

function normalizeSize(params) {
  var s = String((params && (params.imageSize || params.size)) || '1024x1024').trim()
  return ALLOWED_SIZES.indexOf(s) !== -1 ? s : '1024x1024'
}

function normalizeBase64ForAtob(b64) {
  var s = String(b64 || '').replace(/\s/g, '')
  var pad = s.length % 4
  if (pad) s += '===='.slice(0, 4 - pad)
  return s
}

function b64ToPngFile(b64, index) {
  if (typeof atob === 'undefined') {
    throw new Error('当前环境不支持 base64 解码')
  }
  var raw = normalizeBase64ForAtob(b64)
  var bin = atob(raw)
  var len = bin.length
  var bytes = new Uint8Array(len)
  for (var i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i)
  var name = 'gpt-image-1-5-' + Date.now() + '-' + index + '.png'
  return new File([bytes], name, { type: 'image/png' })
}

export function submitVolcGptImage15(params) {
  var cfg = getOpenAIConfig()
  if (!cfg.baseURL) return Promise.reject(new Error('未配置 VUE_APP_OFFICIAL_SORA2_BASE_URL'))
  if (!cfg.apiKey) return Promise.reject(new Error('未配置 VUE_APP_OFFICIAL_SORA2_API_KEY'))

  var prompt = (params.prompt || '').trim()
  if (!prompt) return Promise.reject(new Error('prompt 必填'))

  var body = {
    prompt: prompt,
    model: cfg.model,
    size: normalizeSize(params)
  }

  return axios
    .post(cfg.baseURL + IMAGES_PATH, body, {
      headers: {
        Authorization: 'Bearer ' + cfg.apiKey,
        'Content-Type': 'application/json'
      },
      timeout: 1800000
    })
    .then(function (res) {
      var data = res && res.data
      var list = (data && data.data) || []
      if (!Array.isArray(list) || !list.length) {
        return Promise.reject(new Error('官方接口未返回图片数据'))
      }
      return Promise.all(
        list.map(function (item, idx) {
          var b64 = item && item.b64_json
          if (!b64) return Promise.reject(new Error('官方接口未返回 b64_json'))
          var file = b64ToPngFile(b64, idx)
          return Promise.resolve(file)  // 不再上传，后面统一处理
        })
      )
    })
    .then(function (files) {
      return { files: files, provider: 'official', sync: true }
    })
    .catch(function (err) {
      var msg = extractApiErrorMessage(err.response && err.response.data) || err.message || '请求失败'
      return Promise.reject(new Error(msg))
    })
}
